import styled from "styled-components";
import { Dialog, sz } from "@remhealth/ui";

export const DetailsDialog = styled(Dialog)`
  && {
    width: auto;
    min-width: ${sz(500)};

    dl {
      display: flex;
      flex-flow: row wrap;
    }

    dt {
      flex-basis: 20%;
      text-align: right;
      font-weight: bold;
    }

    dd {
      flex-basis: 80%;
      padding: 0 var(--space-5);
      margin: 0;
    }
  }
`;

export const ResponseBody = styled.div`
  min-height: ${sz(30)};
  line-height: 22px;
  padding: var(--space-4) var(--space-10);
  white-space: pre;
  font-family: monospace;
  font-size: var(--font-size-small);
`;
